import React from 'react'
import Configuration from '../../../../utilities/service/Configuration'

interface AppLocation {
  OpusAPI: string
  NewOpusAPI: string
  PDFRenderAPI: string
}

const AppLocationContext = React.createContext<AppLocation | null>(null)

export function AppLocationProvider({ children }: React.PropsWithChildren) {
  // TODO do something more complicated here
  const result = {
    OpusAPI: Configuration.value('opusAPIURL') ?? 'https://api-opus.uat.intelligent-data-collection.com',
    NewOpusAPI: Configuration.value('newOpusAPIURL') ?? 'https://api-opus.uat.intelligent-data-collection.com/v1',
    PDFRenderAPI: Configuration.value('PDFRenderAPIURL') ?? 'https://api-opus.uat.intelligent-data-collection.com/v1',
  }
  // If we're not running on localhost, replace with real urls
  if (!window.location.host.includes('localhost')) {
    // Get the URL, split it by 1 dot, drop the first part, use the rest as environment suffix
    const parts = window.location.host.split(/\.(.*)/s)
    const url = `https://api-opus.${parts[1]}/v1`

    // All of these API's all have the same API prefix, appearing as 1 API
    result.OpusAPI = url
    result.NewOpusAPI = url
    result.PDFRenderAPI = url
  }

  return <AppLocationContext.Provider value={result}>{children}</AppLocationContext.Provider>
}

export function useAppLocation(): AppLocation {
  const context = React.useContext(AppLocationContext)
  if (context === null) {
    throw new Error('useAppLocation must be used within a AppLocationProvider')
  }
  return context
}
